const mask = {
  phone(phone) {
    if (!phone) return '';
    phone = `${phone}`;
    return `${phone.slice(0, 2)}*****${phone.slice(-2)}`;
  },
  email(email) {
    if (!email) return '';
    const index1 = email.indexOf('@');
    const index2 = email.lastIndexOf('.');
    return `${email.slice(0, 2)}*********${email.slice(
      index1 - 2,
      index1 + 3
    )}****${email.slice(index2 + 1)}`;
  },
};

export default mask;
